import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Capture the `?force_tour=1` QA flag before any auth-redirect strips the
// query string, so <InstalledAppTour/> (which mounts later inside AppShell)
// can still see it. Real installed-PWA detection uses matchMedia and does
// not need this fallback.
try {
  if (typeof window !== "undefined"
      && new URLSearchParams(window.location.search).get("force_tour") === "1") {
    sessionStorage.setItem("powereffect.installed_tour.force", "1");
  }
} catch (err) {
  console.debug("[boot] force_tour capture failed:", err?.message);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker so the app is installable and works offline.
// The SW handles both PWA caching and web-push notifications.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.debug("[SW] registration failed:", err?.message));
  });
}
